const getters = {
    getSaleHierarchyMasterDropDownData(state) {
        return state.salesHierarchyMasterDropDown;
    },
    getSaleHierarchyMasterGridData(state) {
        return state.salesHierarchyMasterArr;
    },
    getSaleHierarchyMasterConfigurationGridData(state) {
        return state.salesHierarchyMasterConfigurationArr;
    },
    getConfigurationDivisionValue(state) {
        return state.configurationDivisionValue;
    },
    getSaleHierarchyMasterUploadGridData(state) {
        return state.salesHierarchyMasterUploadArr;
    },
    getMasterGeoElementData(state) {
        return state.geoElemets;
    },
    getSalesHieDisableGeoData(state) {
        return state.salesHierarchyDtlElemetDisableGeoRole;
    },
};
  
export default getters;
  